module.exports = __webpack_public_path__ + "img/voice-icon3.7299e60.png";